export default __webpack_public_path__ + "static/media/ic_bangladesh.68a0f5dd.svg";